import React from "react";
import { depascalize, Stack, Text } from "sprint-common-web";

import { ContentReferenceType } from "../../../common/types/ContentReferenceType";
import { AssetOperationListItemWithHref } from "../../../content-ingestion/common/asset-operations/AssetOperationList";

export const renderAssetContentDetails = (item: AssetOperationListItemWithHref): JSX.Element => {
    const { content } = item;

    return (
        <Stack tokens={{ childrenGap: 5 }} data-testId="asset-content-details">
            {content.contentTitle && (
                <Text
                    variant="smallPlus"
                    value={content.contentTitle}
                    styles={{ root: { fontWeight: "bold" } }}
                    testId="content-title"
                />
            )}
            {content.contentVersions.map((version, key) => (
                <Text key={`${key}-${version}`} variant="smallPlus" value={version} testId={`version-${key}`} />
            ))}
            {content.contentType && (
                <Text
                    variant="smallPlus"
                    value={`Type: ${depascalize(ContentReferenceType[content.contentType])}`}
                    testId="content-type"
                />
            )}
        </Stack>
    );
};
